import { I18nService } from '@recruitee/i18n';
import type { BillingPlanTier } from '@recruitee/products-types';

const withCustomizedSuffix = (
  text: string,
  addCustom: boolean | undefined,
  i18n: I18nService,
): string => {
  if (addCustom) {
    const suffix = i18n.translate(`app.pricing.product_custom`);
    return `${text} (${suffix})`;
  }

  return text;
};

// eslint-disable-next-line max-lines-per-function
export const getProductName = (
  product: { codename: BillingPlanTier; custom?: boolean },
  i18n: I18nService,
  short?: boolean,
): string => {
  switch (product.codename) {
    case 'launch':
      return withCustomizedSuffix(
        i18n.translate(short ? 'app.pricing.launch' : 'app.pricing.product_name.launch'),
        product.custom,
        i18n,
      );

    case 'scale':
      return withCustomizedSuffix(
        i18n.translate(short ? 'app.pricing.scale' : 'app.pricing.product_name.scale'),
        product.custom,
        i18n,
      );

    case 'lead':
      return withCustomizedSuffix(
        i18n.translate(short ? 'app.pricing.lead' : 'app.pricing.product_name.lead'),
        product.custom,
        i18n,
      );

    case 'start':
      return withCustomizedSuffix(
        i18n.translate(short ? 'app.pricing.start' : 'app.pricing.product_name.start'),
        product.custom,
        i18n,
      );

    case 'grow':
      return withCustomizedSuffix(
        i18n.translate(short ? 'app.pricing.grow' : 'app.pricing.product_name.grow'),
        product.custom,
        i18n,
      );

    case 'optimize':
      return withCustomizedSuffix(
        i18n.translate(short ? 'app.pricing.optimize' : 'app.pricing.product_name.optimize'),
        product.custom,
        i18n,
      );

    default:
      throw new Error(`Unknown product codename "${product ? product.codename : undefined}"`);
  }
};
